<script setup lang="ts">
const userCount = defineModel<number>();
const isShowIcon = ref(true);

watch(
    userCount, 
    () => { isShowIcon.value = false },
    { once: true },
);
</script>

<template>
    <div class="flex-center flex-col lg:flex-row gap-12 lg:gap-6">
        <span class="w-fit block text-body2-bold">تعداد کاربران خود را انتخاب کنید:</span>
        <div class="flex items-center justify-between gap-1 relative">
            <span class="text-gray-400 text-body2-semibold">1 کاربر</span>
            <IconsCurvedArrow 
                v-if="isShowIcon"
                class="w-14 lg:w-25 absolute text-primary-500 -top-25 -right-5 lg:-top-25 lg:-right-12 rotate-12 animation" 
            />
            <InputsRange
                v-model="userCount"
                min="1"
                max="300"
                step="1"
                class="w-50 lg:w-120"
            />
            <span class="text-gray-400 text-body2-semibold">300+ کاربر</span>
        </div>
    </div>
</template>

<style scoped>
.animation {
    animation: animation .5s infinite linear alternate;
}
@keyframes animation {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
</style>